export function defaultRouteForRole(role?: string | null): string {
  switch (role) {
    case 'Admin':
    case 'SuperAdmin':
      return '/admin/users';
    case 'Compliance':
      return '/admin/compliance';
    case 'Finance':
      return '/admin/finance';
    case 'Support':
      return '/admin/support';
    default:
      return '/dashboard';
  }
}

export function safeInternalReturnUrl(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) {
    return null;
  }

  return raw;
}
